import {createAsyncThunk} from '@reduxjs/toolkit';
import {ThunkConfig} from "../../../config/StateSchema";
import {BaseResponse} from "../../../../api/api";
import {IRoomsCollection} from "../../types/roomsTypes";
import {IChatsCollectionsQuery} from "../../../chats/types/chatsTypes";
import {roomsAction} from "../../roomsSlice";
import {snackbarAction} from "../../../errors/SnackbarSlice";

interface IResponse {
    collection: IRoomsCollection[]
}

export const fetchRoomCollection = createAsyncThunk<IRoomsCollection[],
    IChatsCollectionsQuery | void,
    ThunkConfig<string>>(
        'rooms/fetchRoomsCollection',
        async (data, thunkAPI) => {
            const {extra, rejectWithValue, dispatch} = thunkAPI;
            dispatch(roomsAction.clearRooms())
            try {
                const response = await extra.api.get<BaseResponse<IResponse>>('room', {
                    params: data
                })

                if (!response.data.success) {
                    return rejectWithValue('error')
                }

                return response.data.response.collection
            } catch (err) {
                dispatch(snackbarAction.addError('INTERNAL_ERROR'))
                return rejectWithValue('error');
            }
        },
    );
